export default __webpack_public_path__ + "images/ba9c659654daa3b4dd209ff7c8e2ca23-getDiscovered.webp";